import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
declare var alertify:any;
declare var $:any;
@Component({
  templateUrl:"./memberGit.html"
})

export class MemberGit implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService,
    private common:CommonService
  ){}

  private data:any={
    content:[]
  };
  public giftStatus=[];
  public giftTimeType=[];

  private page={
    pageNumber:1,
    size:10,
    search:'',
    status:'',
    startTime:'',
    endTime:'',
    timeType:''
  }
  ngOnInit(): void {
    this.getPath();
    this.initTime();
    this.getGiftStatus();
    this.getGiftTimeType();
  }
  private initTime(){
    setTimeout(res=>{
      $("#startTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,

      }).on('changeDate', function(ev){
        $("#endTime").datetimepicker('setStartDate',$("#startTime").val());
      });

      $("#endTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,

      }).on('changeDate', function(ev){
        $("#startTime").datetimepicker('setEndDate',$("#endTime").val());
      });
    })

  }

  private imagePath:string='';



  //获取gift状态
  private getGiftStatus():void{
    this.http.getData(API.giftStatus).then(res=>{
      this.giftStatus= res.data;
    })
  }

  //获取gift 类型状
  private getGiftTimeType():void{
    this.http.getData(API.giftTimeType).then(res=>{
      this.giftTimeType= res.data;
    })
  }



  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  private getData(){
    let sendData = {
      page:this.page.pageNumber-1,
      size:this.page.size,
      search:this.page.search,
      status:this.page.status,
      startTime:$("#startTime").val(),
      endTime:$("#endTime").val(),
      timeType:this.page.timeType
    }

    for (let i in sendData){
      if(sendData[i] === ''){
        delete sendData[i];
      }
    }
    this.http.postData(API.giftMember,sendData).then(res=>{
      this.data=res.data;

    });
  }

  public search(){
    this.page.pageNumber = 1;
    this.getData();
  }



  private editMember(id:number){
    this.router.navigate(['index/memberGit',id]);
  }
  //删除时间值
  private removeStartTime(){
    $('#startTime').val('');
  }
  private removeEndTimeDetil(){
    $('#endTime').val('');
  }


}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/gift/memberGit.component.ts